import type { Organization } from "schema-dts";

const schema: Organization = {
  "@type": "Organization",
  legalName: "Silversea Cruises Ltd",
  name: "Silversea Cruises",
  url: "https://www.silversea.com/",
  logo: "/silversea-logo.png",
  foundingDate: "1994",
  founders: [
    {
      "@type": "Person",
      name: "Manfredi Lefebvre d'Ovidio",
      url: "https://en.wikipedia.org/wiki/Manfredi_Lefebvre_d%27Ovidio"
    }
  ],
  address: {
    "@type": "PostalAddress",
    streetAddress: "Gildo Pastor Center 7, Rue du Gabian",
    postalCode: "98000",
    addressCountry: "Monaco"
  },
  sameAs: [
    "https://www.instagram.com/silverseacruises/",
    "https://twitter.com/Silversea",
    "https://www.youtube.com/user/SilverseaOfficial",
    "https://www.pinterest.com/silverseacruise/_created/",
    "https://www.facebook.com/SilverseaCruises"
  ]
};

export default schema;
